import actionTypes from './video.actionTypes';
import * as VideoApiService from '../../../Common/Services/VideoApiService';
import config from '../../../../Config';


export const loadVideoPlayer = (companyId, isPublicForm) => {
  return async (dispatch, getState) => {

    if (getState().video.isVideoPlayerLoaded) return;

    jQuery.ajaxSetup({ cache: true });

    let videoConfiguration = getState().video.configuration;
    if (!videoConfiguration) {
      dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_BEGIN });

      let response = await VideoApiService.getVideoConfiguration(companyId, isPublicForm);

      if (response) {        
        let configuration = response;
        dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_SUCCESS, data: { configuration } });
        dispatch(getVideoPlayerScript(configuration));
      }
      else {
        dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_FAILURE });
      }
    }
    else {
      dispatch(getVideoPlayerScript(videoConfiguration));
    }
  };
};

const getVideoPlayerScript = (configuration) => {
  return async (dispatch) => {
    jQuery.getScript(configuration.videoPlayerCdn, ((data, textStatus, jqxhr) => {
      dispatch({ type: actionTypes.SET_VIDEO_PLAYER_LOAD_SUCCESS });
    }))
      .fail((jqxhr, settings, exception) => {
        dispatch({ type: actionTypes.SET_VIDEO_PLAYER_LOAD_FAILURE });
      });    
  };
};

export const loadVideoCreator = (companyId) => {
  return async (dispatch, getState) => {

    //if video creator is loaded, don't continue
     if (getState().video.isVideoCreatorLoaded) return;
     
     //if video creator is not loaded, continue
     jQuery.ajaxSetup({ cache: true });

     //get video configuration
      let videoConfiguration = getState().video.configuration;

      //if video configuration is not loaded, continue
      if (!videoConfiguration) {
        dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_BEGIN });
  
        let response = await VideoApiService.getVideoConfiguration(companyId);
  
        if (response) {
          let configuration = response;
          dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_SUCCESS, data: { configuration } });
          dispatch(getVideoCreatorScript(configuration));
          dispatch(getVideoPlayerScript(configuration));
        }
        else {
          dispatch({ type: actionTypes.GET_VIDEO_CONFIGURATION_FAILURE });
        }
      }
      //if video configuration is loaded, continue
      else {
        dispatch(getVideoCreatorScript(videoConfiguration));
        dispatch(getVideoPlayerScript(videoConfiguration));
      }
}
}

const getVideoCreatorScript = (configuration) => {
  return async (dispatch) => {
    if (window.pctyVideo) return;

    jQuery.getScript(configuration.videoCreatorCdn, ((data, textStatus, jqxhr) => {
      dispatch({ type: actionTypes.SET_VIDEO_CREATOR_LOAD_SUCCESS });
    }))
      .fail((jqxhr, settings, exception) => {
        // if it failed, get the fallback
        jQuery.getScript(configuration.videoCreatorCdnFallback, ((data, textStatus, jqxhr) => {
          dispatch({ type: actionTypes.SET_VIDEO_CREATOR_LOAD_SUCCESS });
        }))
          .fail((jqxhr, settings, exception) => {
            dispatch({ type: actionTypes.SET_VIDEO_CREATOR_LOAD_FAILURE });
          });
      });
  };
};